import React, { ReactNode } from 'react';

import FormGroup from 'components/shared/FormAdapters/FormDefault/FormGroup/Base';
import Center from 'components/shared/Typography/Center';
import Text from 'components/shared/Typography/Text';

function FormErrorText({ children }: { children: ReactNode }) {
  return (
    <FormGroup className="custom-from-error-text-container">
      <Center>
        <Text className={'custom-from-error-text'} type="danger">
          {children}
        </Text>
      </Center>
    </FormGroup>
  );
}

export default FormErrorText;
